import React from 'react'
import SettingPage, {
    SettingLinkGrid,
    SettingPanel,
} from '@/views/main/modules/member-manage/member-setting/setting-page'
import { MEMBER_POINTS_SETTING, MEMBER_RECHARGE_SETTING } from '@/views/main/modules/member-manage/router'

import './marketing.scss'

const Marketing: React.FC = () => (
    <SettingPage title="营销玩法" className="store-setting-page marketing-home">
        <div className="store-setting-page__heading">
            <h1 className="store-setting-page__title">营销玩法</h1>
            <p className="store-setting-page__subtitle">选择需要配置的会员活动规则。</p>
        </div>
        <SettingPanel title="活动配置" desc="与会员设置使用同一份规则，无需重复设置。">
            <SettingLinkGrid
                columns={2}
                items={[
                    {
                        title: '充值送',
                        desc: '设置充值赠送档位与自定义充值金额',
                        route: MEMBER_RECHARGE_SETTING,
                    },
                    {
                        title: '积分福利',
                        desc: '设置积分获取、抵现及适用场景',
                        route: MEMBER_POINTS_SETTING,
                    },
                ]}
            />
        </SettingPanel>
    </SettingPage>
)

export default Marketing
